import ServiceExec from '@/common/utils/ServiceExec';
import { forEach } from 'lodash';

class InfoSvc extends ServiceExec {
  /**
   * 전문가 회사 정보 가져옥
   * @returns {*}
   */
  getCompanyList() {
    return this.get(`/common/companies`).then((response) => {
      return response.data;
    });
  }

  /**
   *  전문가 정보 가져오기
   *  @param Authorization {string} Authorization
   */
  getMapExpert(params = {}) {
    return this.get(`/api/expert`, params).then((response) => {
      return response.data;
    });
  }

  refreshExpertInfo(params = {}) {
    return this.post(`/api/expert/eclean-info`, params).then((response) => {
      return response.data;
    });
  }
  /**
   *  전문가 설계사 정보 조회
   *  @param Authorization {string} Authorization
   */
  getMapExpertInfo(params = {}) {
    return this.get(`/api/expert/eclean-info`, params).then((response) => {
      return response.data;
    });
    // return this.get(`/api/expert/info/getMapExpertInfo`, params).then((response) => {
    //   return response.data;
    // });
  }

  /**
   *  전문가 정보 수정
   *  @param Authorization {string} Authorization
   *  @param expertDTO {string} expertDTO
   */
  patchIntExpert(params = {}, file) {
    const formData = new FormData();
    formData.append('body', new Blob([JSON.stringify(params)], { type: 'application/json' }));
    formData.append('file', file);

    return this.patch(`/api/expert/my-info`, formData).then((response) => {
      return response.data;
    });
    // return this.patch(`/api/expert/info/patchIntExpert`, params).then((response) => {
    //   return response.data;
    // });
  }

  /**
   *  전문가 프로필이미지 변경
   *  @param Authorization {string} Authorization
   *  @param imagePath {string} imagePath
   */
  patchIntExpertImagePath(params = {}) {
    const formData = new FormData();
    forEach(params, function (value, key) {
      formData.append(key, value);
    });
    return this.patch(`/api/expert/info/patchIntExpertImagePath`, formData).then((response) => {
      return response.data;
    });
  }

  /**
   *  전문가 이용권 타입별 내역 가져오기
   *  @param Authorization {string} Authorization
   *  @param limit {integer}
   *  @param page {integer}
   *  @param types {ref} 타입(1: 컨설턴트 , 2: 전문가클럽)
   */
  getListExpertTicket(params = {}) {
    return this.get(`/api/expert/tickets`, params).then((response) => {
      return response.data;
    });
  }

  cancelExpertTicket(ticketNo) {
    return this.post(`/api/expert/tickets/${ticketNo}/cancel`).then((response) => {
      return response.data;
    });
  }

  getTicketStatus(params = {}) {
    return this.get(`/api/expert/ticket-status`, params).then((response) => {
      return response.data;
    });
  }

  /**
   *  전문가 탈퇴
   *  @param Authorization {string} Authorization
   */
  patchIntWthdr(params = {}) {
    return this.patch(`/api/expert/info/patchIntWthdr`, params).then((response) => {
      return response.data;
    });
  }

  /**
   *  전문가 비밀번호 변경
   *  @param Authorization {string} Authorization
   *  @param newPassword {string} newPassword
   *  @param oldPassword {string} oldPassword
   */
  patchMapPassword(params = {}) {
    return this.patch(`/api/expert/password/change`, {
      password: params.oldPassword,
      newPassword: params.newPassword
    }).then(() => {
      return { code: 1 };
    });
  }
}

export default new InfoSvc();
